export default function initHeader() {
    const menuTrigger = document.getElementById("menu-trigger");
    const header = document.getElementById("header");
    if (!menuTrigger || !header)
        return;
    menuTrigger.addEventListener("click", () => {
        menuTrigger.classList.toggle("active");
        header.classList.toggle("menu-open");
    });
}
